import React from 'react'
import PropTypes from 'prop-types'
import states from './helpers/USStates'

const StateSelect = ({ onChange, className, defaultValue, id }) => {
  return (
    <select
      id={id}
      onChange={onChange}
      className={className}
      defaultValue={defaultValue ? defaultValue : 'default'}
    >
      <option disabled value="default">State</option>
      {states.map(([state, abbreviation]) => {
        return <option key={state} value={abbreviation}>{state}</option>
      })}
    </select>
  )
}

StateSelect.propTypes = {
  className:    PropTypes.string,
  defaultValue: PropTypes.string,
  id:           PropTypes.string,
  onChange:     PropTypes.func
}

export default StateSelect
